// extracted by mini-css-extract-plugin
module.exports = {"editor":"Editor-module--editor--3NFj2","slideDown":"Editor-module--slideDown--11A6g"};